module.exports = __webpack_public_path__ + "img/typesetting_20pt.89315f20.svg";